import { render, staticRenderFns } from "./AdminCourseStates.vue?vue&type=template&id=05dae6ee&"
import script from "./AdminCourseStates.vue?vue&type=script&lang=js&"
export * from "./AdminCourseStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports